import { Reveal } from "../landing/Reveal";
import type { UseCaseConfig } from "../../use-cases/types";

interface PillarsProps {
  pillars: UseCaseConfig["pillars"];
}

/**
 * "Why this fits the space" three-up. Replaces the original WhyK12 with a
 * config-driven version so each vertical can land its own three benefits.
 */
export const Pillars = ({ pillars }: PillarsProps) => (
  <section className="bg-white py-24 md:py-32 px-6 md:px-16 lg:px-24">
    <div className="max-w-5xl mx-auto">
      <Reveal>
        <span className="text-fwd-red text-xs font-bold tracking-[0.2em] uppercase block mb-4">
          {pillars.eyebrow}
        </span>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-display text-[clamp(2rem,3.6vw,3rem)] font-normal leading-tight text-fwd-ink mb-16 max-w-3xl">
          {pillars.headline}
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 lg:gap-x-14 gap-y-12">
        {pillars.points.map((p, i) => (
          <Reveal key={p.title} delay={Math.min(i * 0.1, 0.3)}>
            <div className="border-t-2 border-fwd-ink pt-6">
              <h3 className="font-display text-xl md:text-2xl text-fwd-ink leading-snug mb-3">
                {p.title}
              </h3>
              <p className="font-serif text-fwd-ink/70 text-lg leading-relaxed">
                {p.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
